import React from "react";
import { useIntl } from "react-intl";
import { Modal } from "@jelly/ui";

import styles from "./Modals.module.scss";
import { messages } from "../inAutomotive.messages";
import { useUi } from "@jelly/lesson";
import { nl2p } from "@src/utils/nl2p";

type ModalProps = Omit<React.ComponentProps<typeof Modal>, "children">;

export const PhysicalPrototypingModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.C8_P2_M_PhysicalPrototyping_Title)}>
      <div className={styles.root}>
        <div className={styles.oneColumn}>
          <div className={styles.leftColumn}>
            {nl2p(formatMessage(messages.C8_P2_M_PhysicalPrototyping_Description))}
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const VirtualPrototypingModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.C8_P2_M_VirtualPrototyping_Title)}>
      <div className={styles.root}>
        <div className={styles.oneColumn}>
          <div className={styles.leftColumn}>
            {nl2p(formatMessage(messages.C8_P2_M_VirtualPrototyping_Description))}
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const MusicSystemsModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.C8_P2_M_MusicSystems_Title)}>
      <div className={styles.root}>
        <div className={styles.oneColumn}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.C8_P2_M_MusicSystems_Description))}</div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const AudioZonesModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.C8_P2_M_AudioZones_Title)}>
      <div className={styles.root}>
        <div className={styles.oneColumn}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.C8_P2_M_AudioZones_Description))}</div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const DirectionalAlertsModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.C8_P2_M__DirectionalAlerts_Title)}>
      <div className={styles.root}>
        <div className={styles.oneColumn}>
          <div className={styles.leftColumn}>
            {nl2p(formatMessage(messages.C8_P2_M__DirectionalAlerts_Description))}
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};
